import { IonAlert, IonBackButton, IonButton, IonButtons, IonCard, IonCol, IonContent, IonGrid, IonHeader, IonIcon, IonItemDivider, IonLabel, IonPage, IonRow, IonSpinner, IonTitle, IonToolbar } from '@ionic/react'
import { arrowBack, arrowForward } from 'ionicons/icons'
import React, { useState } from 'react'
import { sendFriendRequest } from '../helpers/friend_actions'
import { goToPage } from '../helpers/app_actions'
import { ProfileI } from '../interfaces/Profile'
import { SafetyPadding } from '../components/SafetyPadding'
import Api from "../services/Api"

export const SearchFriends = () => {
  const api = Api.getInstance()
  const [searchOpen, setSearchOpen] = useState(false)
  const [loading, setLoading] = useState(false)
  const [searchState, setSearchState] = useState({
    name: '',
    email: '',
    errorText: '',
    error: false,
    found: false,
    emailFriend: {} as ProfileI,
    sent: false,
    matchingFriends: [] as Array<ProfileI>
  }) 

  const searchEmailFriend = () => {
    // this.setState({emailFriend: {} as ProfileI})
    api.get('friend_search/' + searchState.email).then(result => {
      if (result.ok) {
        result.json().then(resultJson => {
          if (resultJson.status === 'ok') {
            setSearchState({
              ...searchState, 
              found: true,
              emailFriend: resultJson.emailFriend
            })
            setLoading(false)
          } else {
            setSearchState({
              ...searchState, 
              found: false,
              error: true,
              errorText: resultJson.message,
            })
            setLoading(false)
          }
        });
      } else {
        setSearchState({
          ...searchState, 
          found: false,
          error: true,
          errorText: api.tr('cannot_find_email_error') + searchState.email
        })
      }
    });
  }

  const searchNameFriend = () => {
    // this.setState({emailFriend: {} as ProfileI})
    api.get('friend_search_pattern/' + searchState.name).then(result => {
      if (result.ok) {
        result.json().then(data => {
          if (data.status === 'ok') {
            setSearchState({
              ...searchState, 
              // found: true,
              matchingFriends: data.matchingFriends
            })
            setLoading(false)

          } else {
            setSearchState({
              ...searchState, 
              found: false,
              error: true,
              errorText: data.message,
            })
            setLoading(false)
          }
        });
      } else {
        setSearchState({
          ...searchState, 
          found: false,
          error: true,
          errorText: api.tr('cannot_find_email_error') + searchState.email
        })
      }
    });
  }

  const closeModal = () =>  {
    setSearchState({
      ...searchState,
      email: '',
      errorText: '',
      error: false,
      found: false,
      emailFriend: {} as ProfileI,
      sent: false
    })
    setSearchOpen(false)
  }

  return (
  <IonPage className="cheap_desktop">
    <IonHeader>
      <IonToolbar>
        <IonButtons slot="start">
          <IonBackButton/>
        </IonButtons>
        <IonTitle>{api.tr('add_friends_with_email')}</IonTitle>
      </IonToolbar>
    </IonHeader>
    <IonContent>
      <IonItemDivider class="mt-3">
        <IonLabel slot="start" className="p-2">{api.tr('search_person_name')}</IonLabel>
      </IonItemDivider>
      <IonRow class="p-2">
        <article className={`modalInput fullWidth`}>
          <input
            type="text"
            id="name"
            value={searchState.name}
            onChange={(e) => {
              setSearchState({
                ...searchState,
                email: '',
                name: e.target.value
              })
            }}
            maxLength={60}
            disabled={searchState.email !== ''}
            required
            className={`focused ${searchState.error ? 'border_error' : `${searchState.name !== '' ? 'border_primary' : 'border_gray'}` }`}/>
          <label htmlFor="title">{api.tr('name')}</label>
        </article>
      </IonRow>
    <IonItemDivider 
      class="mt-3">
      <IonLabel slot="start" className="p-2">{api.tr('search_email')}</IonLabel>
    </IonItemDivider>
     <IonRow class="p-2">
        <article className={`modalInput fullWidth`}>
          <input
            type="text"
            id="email"
            value={searchState.email}
            onChange={(e) => {
              setSearchState({
                ...searchState,
                name: '',
                email: e.target.value
              })
            }}
            // onFocus={clearFieldOnFocus}
            // onBlur={fillFieldOnBlur}
            maxLength={60}
            required
            disabled={searchState.name !== ''}
            className={`focused ${searchState.error ? 'border_error' : `${searchState.email !== '' ? 'border_primary' : 'border_gray'}` }`}/>
          <label htmlFor="title">{api.tr('email')}</label>
        </article>
      </IonRow>
      <IonRow class="p-2">
        <IonButton
          class="fullWidth"
          fill="outline"
          onClick={() => {
            if(searchState.email !== ''){
              searchEmailFriend()
              setLoading(true)
            } else if(searchState.email === '' && searchState.name !== ''){
              searchNameFriend()
              setLoading(true)
            } else {
              setSearchState({
                ...searchState,
                error: true,
                errorText: api.tr('no_email_error'),
                emailFriend: {} as ProfileI,
                found: false
              })
            }
          }}>
            {api.tr('search_person_button')}
        </IonButton>
      </IonRow>
      <IonRow class="flex justify-center items-center p-4">
        { loading ? <IonSpinner name="lines" /> : null}
      </IonRow>
        { searchState.found ?
          <IonGrid>
            <IonItemDivider 
              class="mt-3"
              color="darkblue">
              <IonLabel slot="start" className="p-2">{api.tr('search_result')}</IonLabel>
            </IonItemDivider>
            <IonRow>
              <IonCard class="fullWidth p-2 m-2">
                <IonRow>
                  <IonCol size="4">
                    <img src={searchState.emailFriend.picture} alt="" className="circle"/>
                  </IonCol>
                  <IonCol class="flex items-center">
                    <h2>{searchState.emailFriend.firstName}</h2>
                  </IonCol>
                </IonRow>
                <IonRow class="mt-2">
                  <IonButton
                    class="fullWidth"
                    onClick={() => {
                      sendFriendRequest(searchState.emailFriend.id).then((success: boolean) => {
                        if (success) {
                          setSearchState({
                            ...searchState,
                            sent: true
                          })
                        } else {
                          setSearchState({
                            ...searchState,
                            error: true,
                            errorText: api.tr('something_went_wrong')
                          })
                        }
                      })
                    }}>
                      Bli vän
                  </IonButton>
                  <IonButton 
                    class="fullWidth mt-2"
                    onClick={() => {
                      goToPage('/walk/user/profile/' + searchState.emailFriend.id)
                      // setFriendsListOpen(false)
                    }}
                    fill="outline">
                      {api.tr('go_to')} {searchState.emailFriend.firstName} {api.tr('go_to_profile')} 
                      <IonIcon icon={arrowForward} />
                  </IonButton>
                </IonRow>
              </IonCard>
            </IonRow>
            <IonRow>
              <IonAlert
                isOpen={searchState.sent}
                onDidDismiss={() => setSearchState({
                  name: '',
                  email: '',
                  errorText: '',
                  error: false,
                  found: false,
                  emailFriend: {} as ProfileI,
                  sent: false,
                  matchingFriends: []
                })}
                cssClass='alert-window'
                header={'Skickad'}
                message={`Vänförfrågan är skickad till ${searchState.emailFriend.firstName}`}
                buttons={[ 
                {
                  text: api.tr('close'),
                  role: 'cancel',
                  cssClass: 'secondary',
                  handler: () => closeModal()
              },{
                text: api.tr('add_more_friends'),
                role: 'cancel',
                cssClass: 'secondary',
                handler: () => setSearchState({
                  name: '',
                  email: '',
                  errorText: '',
                  error: false,
                  found: false,
                  emailFriend: {} as ProfileI,
                  sent: false,
                  matchingFriends: []
                })}
              ]}/>
            </IonRow>
          </IonGrid>
        : 
        <>
          { searchState.matchingFriends.length > 0 ? 
          <IonGrid>
            <IonItemDivider 
              class="mt-3"
              color="darkblue">
              <IonLabel slot="start" className="p-2">{api.tr('search_result')}</IonLabel>
              <IonLabel slot="end">{searchState.matchingFriends.length} {api.tr('persons_found')}</IonLabel>
            </IonItemDivider>
            { searchState.matchingFriends.map((foundPerson: ProfileI, key: any) => {
              return <IonRow key={'matchingSearch' + key + foundPerson.id}>
                <IonCard class="fullWidth p-2 m-2 ">
                  <IonRow>
                    <IonCol>
                      <img src={foundPerson.picture} alt="" className="circle_large"/>
                    </IonCol>
                    <IonCol size="9" class="p-2">
                      <IonRow>
                        <h2 className="ml-2">{foundPerson.firstName}</h2>
                      </IonRow>
                      <IonRow>
                        <IonButton
                          size="small"
                          class="fullWidth mt-2 ml-2"
                          onClick={() => {
                            sendFriendRequest(foundPerson.id).then((success: boolean) => {
                              if (success) {
                                setSearchState({
                                  ...searchState,
                                  sent: true
                                })
                              } else {
                                setSearchState({
                                  ...searchState,
                                  error: true,
                                  errorText: api.tr('something_went_wrong')
                                })
                              }
                            })
                          }}>
                          {api.tr('become_friend')}
                        </IonButton>
                      </IonRow>
                      <IonRow>
                        <IonButton 
                          size="small"
                          class="fullWidth mt-2 ml-2"
                          onClick={() => {
                            setSearchOpen(false)
                            goToPage('/walk/user/profile/' + foundPerson.id)
                          
                          }}
                          fill="outline">
                            {api.tr('go_to')} {api.tr('go_to_profile')} 
                            <IonIcon icon={arrowForward} />
                        </IonButton>
                      </IonRow>
                    </IonCol>
                  </IonRow>
                  <IonRow class="mt-2">
                  </IonRow>
                </IonCard>
                <IonAlert 
                  isOpen={searchState.sent}
                  onDidDismiss={() => setSearchState({
                    name: '',
                    email: '',
                    errorText: '',
                    error: false,
                    found: false,
                    emailFriend: {} as ProfileI,
                    sent: false,
                    matchingFriends: []
                  })}
                  cssClass='alert-window'
                  header={'Skickad'}
                  message="Vänförfrågan är skickad"
                  buttons={[ 
                  {
                    text: api.tr('close'),
                    role: 'cancel',
                    cssClass: 'secondary',
                    handler: () => closeModal()
                },{
                  text: api.tr('add_more_friends'),
                  role: 'cancel',
                  cssClass: 'secondary',
                  handler: () => setSearchState({
                    name: '',
                    email: '',
                    errorText: '',
                    error: false,
                    found: false,
                    emailFriend: {} as ProfileI,
                    sent: false,
                    matchingFriends: []
                  })}
                ]}/>
            </IonRow>
            })}
          </IonGrid>
         : null }
        </>
        }
      <IonAlert 
        isOpen={searchState.error}
        onDidDismiss={() => setSearchState({
          ...searchState,
          error: false
        })}
        cssClass='alert-window'
        header={api.tr('error_message')}
        message={searchState.errorText}
        buttons={[ 
        {
          text: api.tr('close'),
          role: 'cancel',
          cssClass: 'secondary',
          handler: () => setSearchState({
            ...searchState,
            error: false
          })
      }]}/>
      <SafetyPadding/>
    </IonContent>
  </IonPage>

  )
}
